import { Component, OnInit, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ILoginUser_Request } from "../../../Utils/_services/account/account.model";
import { ICustomError } from "../../../Utils/_models/network-response";
import { AccountService } from "../../../Utils/_services/account/account.service";
import { finalize } from "rxjs";
import { LeftUiTemplateComponent } from "../left-ui-template/left-ui-template.component";
import { environment } from "../../../environments/environment";
import { SessionService } from "../../../Utils/_services/session/session.service";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, LeftUiTemplateComponent],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.css",
})
export class LoginComponent implements OnInit {
  loginModel: ILoginUser_Request = {
    email: "",
    password: "",
    loginType: "email",
  };
  isLoading = signal(false);
  showPassword = false;
  errorMessage = "";
  rememberMe = false;
  year = signal(new Date().getFullYear());
  pwaUrl: string = `${environment.pwaFrontendBaseUrl}/signup`;

  constructor(
    private accountService: AccountService,
    private sessionService: SessionService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const savedCredentials = localStorage.getItem("rememberedCredentials");
    if (savedCredentials) {
      const credentials = JSON.parse(savedCredentials);
      this.loginModel.email = credentials.email;
      this.rememberMe = true;
    }
  }

  onSubmit(): void {
    if (this.isLoading()) return;

    if (!this.loginModel.email || !this.loginModel.password) {
      this.errorMessage = "Please enter both username/email and password.";
      return;
    }

    this.isLoading.set(true);
    this.errorMessage = "";

    this.accountService
      .login(this.loginModel, this.rememberMe)
      .pipe(
        finalize(() => {
          this.isLoading.set(false);
        })
      )
      .subscribe({
        next: response => {
          if (response.auth.success) {
            this.toastr.success("Logged in successfully");
            if(this.rememberMe)
            {
              var credentails = { email: this.loginModel.email };
              localStorage.setItem("rememberedCredentials", JSON.stringify(credentails));
            }
            else{
              localStorage.removeItem("rememberedCredentials");
            }

            if (response.data.role === "admin" || response.data.role === "super_admin") {
              this.router.navigate(["/admin/dashboard"]);
            } else {
              this.toastr.error(response.msg);
              this.router.navigate(["/"]);
              // GET JWT and user data to forward to PWA login
              // const userData = this.sessionService.getCurrentUser();
              // if (userData) {
              //   this.sessionService.clearSession();
              //   localStorage.removeItem("user");
              //   const adoreTheBallonUrlPlusJwt = `${environment.pwaFrontendBaseUrl}/auth/login?id=${encodeURIComponent(userData.uuidv4Id)}`;
              //   window.open(adoreTheBallonUrlPlusJwt, "_self");
              // }
            }
          } else {
            this.toastr.error(response.msg);
          }
        },
        error: (error: ICustomError) => {
          this.errorMessage = error?.error?.msg ?? error;
        },
      });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  onSignUpClick() {
    this.toastr.warning("Download The App");
  }

  navigateToRegister(): void {
    this.router.navigate(["/home/register"]);
  }

  navigateToForgotPassword(): void {
    this.router.navigate(["/forgot"]);
  }

  clearError(): void {
    this.errorMessage = "";
  }
}
